import React from 'react';
import '../styles/ManualModal.css';

/**
 * ManualSelectionModal
 * A clean, premium modal for picking the manual language.
 */
export default function ManualSelectionModal({ isOpen, onClose, onNavigate }) {
  if (!isOpen) return null;

  const manuals = [
    { id: 'en', label: 'English', sub: 'Default Manual', icon: '🇬🇧', file: '/manuals/user_manual_en.pdf' },
    { id: 'te', label: 'Telugu', sub: 'తెలుగు వెర్షన్', icon: '🇮🇳', file: '/manuals/user_manual_te.pdf' },
    { id: 'hi', label: 'Hindi', sub: 'हिन्दी संस्करण', icon: '🇮🇳', file: '/manuals/user_manual_hi.pdf' }
  ];

  const handleSelect = (file) => {
    window.open(file, '_blank');
    onClose();
  };

  return (
    <div className="manual-modal-overlay" onClick={onClose}>
      <div className="manual-modal-content" onClick={e => e.stopPropagation()}>
        <div className="manual-modal-header">
          <h3>Select Language</h3>
          <p>Choose your preferred language for the User Manual</p>
          <button className="manual-modal-close" onClick={onClose}>&times;</button>
        </div>
        
        <div className="manual-modal-grid">
          {manuals.map(m => (
            <div key={m.id} className="manual-lang-card" onClick={() => handleSelect(m.file)}>
              <div className="manual-lang-icon">{m.icon}</div>
              <div className="manual-lang-info">
                <div className="manual-lang-label">{m.label}</div>
                <div className="manual-lang-sub">{m.sub}</div>
              </div>
              <div className="manual-lang-arrow">→</div>
            </div>
          ))}
        </div>
        
        <div className="manual-modal-footer">
          Need more help? <a onClick={() => { 
            if (onNavigate) {
              onNavigate('Support');
            } else {
              window.dispatchEvent(new CustomEvent('pg:navigate', { detail: { goto: 'Support' } }));
            }
            onClose(); 
          }}>Contact Support</a>
        </div>
      </div>
    </div>
  );
}
